import React from 'react';

import { Stack, Typography } from '@mui/material';

import BlockInput from './BlockInput';

type TProps = {
  name: string;
  title: string;
  inputs: Parameters<typeof BlockInput>[0]['input'][];
};

export default function BlockInputSection({ name, title, inputs }: TProps) {
  return (
    <>
      <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
        {title}
      </Typography>
      <Stack spacing={5} mb={3}>
        {inputs.map((input, index) => (
          <BlockInput key={index} name={name} input={input} />
        ))}
      </Stack>
    </>
  );
}
